// @ts-nocheck
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaCheck } from 'react-icons/fa';
import AlbanianFlag from '../assets/icons/albania.svg';
import EnglishFlag from '../assets/icons/EnglishFlag.png';
import ItalianFlag from '../assets/icons/italianFlag.png';
import GermanFlag from '../assets/icons/GermanFlag.png';
import SpainFlag from '../assets/icons/SpainFlag.png';
import PolishFlag from '../assets/icons/polish.png';
import UkraineFlag from '../assets/icons/Flag_of_Ukraine_Flat_Round-64x64.png';

const LanguageSelector = ({ variant = 'default' }) => {
    const { i18n } = useTranslation();
    const [selectedLang, setSelectedLang] = useState(i18n.language || 'sq');

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        setSelectedLang(lng);
    };

    const languages = [
        { code: 'sq', img: AlbanianFlag, label: 'Shqip' },
        { code: 'en', img: EnglishFlag, label: 'English' },
        { code: 'it', img: ItalianFlag, label: 'Italiano' },
        { code: 'de', img: GermanFlag, label: 'Deutsch' },
        { code: 'es', img: SpainFlag, label: 'Español' },
        { code: 'pl', img: PolishFlag, label: 'Polski' },
        { code: 'ukr', img: UkraineFlag, label: 'Українська' },
    ];

    if (variant === 'mobile') {
        return (
            <div className="grid grid-cols-4 gap-3 p-2">
                {languages.map((lang) => (
                    <button
                        key={lang.code}
                        onClick={() => changeLanguage(lang.code)}
                        className={`relative group flex flex-col items-center justify-center p-2 rounded-lg transition-all duration-300 ${selectedLang === lang.code
                                ? 'bg-white shadow-md ring-2 ring-gold scale-105'
                                : 'bg-white/50 hover:bg-white hover:shadow-sm opacity-70 hover:opacity-100'
                            }`}
                    >
                        <div className="w-8 h-8 rounded-full overflow-hidden mb-1 shadow-sm border border-gray-100">
                            <img src={lang.img} alt={lang.label} className="w-full h-full object-cover" />
                        </div>
                        {selectedLang === lang.code && (
                            <div className="absolute top-1 right-1 bg-gold rounded-full p-0.5 shadow-sm">
                                <FaCheck className="w-2 h-2 text-white" />
                            </div>
                        )}
                        <span className={`text-[10px] uppercase font-bold tracking-wider ${selectedLang === lang.code ? 'text-dark-chocolate' : 'text-gray-500'
                            }`}>
                            {lang.code}
                        </span>
                    </button>
                ))}
            </div>
        );
    }

    // Default / Desktop Float Variant
    return (
        <div className="grid grid-cols-3 gap-3 p-1">
            {languages.map((lang) => (
                <button
                    key={lang.code}
                    onClick={() => changeLanguage(lang.code)}
                    className={`relative w-10 h-10 rounded-full transition-all duration-300 transform ${selectedLang === lang.code
                            ? 'ring-2 ring-gold scale-110 shadow-md opacity-100'
                            : 'opacity-50 hover:opacity-100 hover:scale-105 grayscale hover:grayscale-0'
                        }`}
                    title={lang.label}
                >
                    <img src={lang.img} alt={lang.label} className="w-full h-full rounded-full object-cover shadow-sm" />
                    {selectedLang === lang.code && (
                        <div className="absolute -bottom-1 -right-1 bg-gold text-white rounded-full p-1 shadow-sm">
                            <FaCheck className="w-2 h-2" />
                        </div>
                    )}
                </button>
            ))}
        </div>
    );
};

export default LanguageSelector;
